<!-- Submit Button -->
<div class="row justify-content-md-right">
  <div class="col-md-10"></div>
  <div class="col-md-2">
    <button type="submit" class="btn btn-sm btn-success btn-block" [disabled]="!formIsValid">Send</button>
  </div>
</div>
<!-- / Submit Button -->



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/submission/app-submission.component.html